import styled from "styled-components";
import Colors from "../../../../constants/Colors";

interface TextProps {
  color?: string;
  bold?: boolean;
  textAlign?: string;
  position?: string;
}

export const Container = styled.div<{ isMobile?: boolean }>`
  width: ${(props) => (props.isMobile ? "90vw" : "100%")};
`;
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
`;
export const SolidButton = styled.div<{
  color?: string;
  disabled?: boolean;
  inverted?: boolean;
  width?: number;
}>`
  background-color: ${(props) =>
    props.color ? props.color : props.inverted ? "#E0F0F5" : Colors.lightBlue};
  display: flex;
  color: ${(props) => (props.inverted ? Colors.SPM600 : "white")};
  width: ${(props) => (props.width !== null ? `${props.width}%` : "auto")};
  flex-direction: row;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  border: ${(props) =>
    props.inverted ? "0px solid #4D638D" : "0px solid #4D638D"};
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  letter-spacing: 0.5px;

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? "text" : "pointer")};
  }

  &:active {
    background-color: ${(props) => (props.disabled ? "" : "#D7DDF4")};
    color: ${(props) => (props.disabled ? "" : Colors.lightBlue)};
    border-color: ${(props) => (props.disabled ? "" : "#D7DDF4")};
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  @media screen and (max-width: 620px) {
    flex-direction: column;
  }
`;
export const Table = styled.table<{ isMobile?: boolean }>`
  width: 100%;

  display: ${(props) => (props.isMobile ? "block" : null)};
  overflow-x: ${(props) => (props.isMobile ? "auto" : "none")};
  white-space: ${(props) => (props.isMobile ? "nowrap" : "none")};

  border-collapse: collapse;
`;

export const HeaderTable = styled.thead``;
export const TR = styled.tr``;
export const TBody = styled.tbody`

`;

export const ListContainer = styled.div`
  background-color: white;
  height: 65vh;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #e0f0f5;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #556ed1;
    border-radius: 5px;
  }

  @media screen and (max-width: 1500px) {
    height: 55vh;
  }
`;

export const AttendanceCardContainer = styled.tr`
  border: none;
  padding: 12px 24px;
  gap: 16px;
  background: ${Colors.GRAY50};
  border-radius: 8px;
  width: 100%;
`;
export const Icon = styled.img<{ width: number; height: number }>`
  width: ${(props) => props.width + "px"};
  height: ${(props) => props.height + "px"};
  cursor: pointer;
`;

export const Title = styled.th<TextProps>`
  word-break: break-word;
  color: ${(props) => (props.color ? props.color : "#101828")};
  font-size: 16px;
  font-weight: ${(props) => (props.bold ? "bold" : "")};
  font-family: "Inter", sans-serif;
  text-align: start;
  padding-right: 10px;
`;
export const ContentCard = styled.td<TextProps>`
  word-break: break-word;
  color: ${(props) => (props.color ? props.color : "#101828")};
  font-size: 16px;
  font-weight: ${(props) => (props.bold ? "bold" : "")};
  font-family: "Inter", sans-serif;
  text-align: ${(props) => (props.position ? props.position : "start")};
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  border-bottom: 5px solid white;
`;
export const Detail = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  color: ${Colors.SPM500};
`;
export const BoxDetail = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  cursor: pointer;
`;
